export default "__VITE_ASSET__Wx0EtDcB__"